export default __webpack_public_path__ + "static/media/pcard5.a1e54c4a.png";